export function assert(condition: boolean, message: string): asserts condition {
  console.assert(condition, message)
}
